import { List } from "@chakra-ui/react";
import type React from "react";

const CustomList = {
  Root: (props: React.ComponentProps<typeof List.Root>) => (
    <List.Root {...props} />
  ),
  Item: (props: React.ComponentProps<typeof List.Item>) => (
    <List.Item {...props} />
  ),
};

interface FaceliftListProps
  extends React.ComponentProps<typeof List.Root> {
  children: React.ReactNode;
}

interface FaceliftListItemProps
  extends React.ComponentProps<typeof List.Item> {
  children: React.ReactNode;
}

const FaceliftList: React.FC<FaceliftListProps> & {
  Item: React.FC<FaceliftListItemProps>;
} = ({ children, ...rest }) => {
  return (
    <CustomList.Root
      gap="12px"              // spacing between items
      pl="20px"               // left padding for markers
      listStyleType="upper-alpha"
      {...rest}
    >
      {children}
    </CustomList.Root>
  );
};

FaceliftList.Item = ({ children, ...rest }) => {
  return (
    <CustomList.Item {...rest}>
      {children}
    </CustomList.Item>
  );
};

export default FaceliftList;
